import React from 'react'
import categories from '../categories';
import './css.css'

export default function Selects(props) {
  const sizes = ["XS","S","M","L","XL","XXL", "XXXL"];
  const sizesPants = ["38","39","40","41","42","43","44","45","46","47","48"];

  const sizesVisible = () => {
    if(props.category !== "" && 
          props.category !== "barbijo" && 
          props.category !== "wallet" && 
          props.category !== "fragrance" &&
          props.category !== "accesory")
        return true;
    return false;
  }
    return (
        <React.Fragment>
          <div className="content-select">
            <span>Categoría </span>
            <div className="flecha-select"></div>
            <select onChange={props.handleChangeCategory} className="select"  value={props.category}>
            {!props.multiple && <option value="">Todo</option>}
            {categories && categories.map((c, index) => <option key={index} value={c.name}>{c.value === "Pantalón" ? "Pantalones" : c.value + "s"}</option>)}
            </select>
          </div>
          {sizesVisible() &&
            <div className="content-select">
              <span>Talles</span>
              <div className="flecha-select"></div>
              <select onChange={props.handleChangeSizes} className="select" multiple={props.multiple} value={props.sizes}>
                {!props.multiple && <option value="">Todos</option>}
                {props.category === 'pant' || props.category === 'shoes'
                ? sizesPants && sizesPants.map((s, index)=> <option key={index} value={s}>{s}</option>)
                : sizes && sizes.map((s, index)=> <option key={index} value={s}>{s}</option>)
                }
                {props.multiple && props.category === 'suit' && 
                sizesPants && sizesPants.map((s, index)=> <option key={index} value={s}>{s}</option>)
                }
              </select>
              
            </div>
          }
        </React.Fragment>
  )
}